// components/Authors/sidebar.jsx
import React, { useEffect, useMemo, useState } from "react";
import StickyBox from "react-sticky-box";
import { Link, useLocation, useParams } from "react-router-dom";
import { User1 } from "../../imagepath";
import { buildAuthorPath, extractIdFromSlug } from "../../../utils/slugify";
// ⬇️ opsiyonel fetch: author prop yoksa kullanacağız
import { getAuthorDetail } from "../../../services/authorService";
import { useContext } from "react";
import { AppContext } from "../../../services/AuthContext";
import { getFilePath } from "../../../services/axiosInstance";


export default function InstructorSidebar({ author: authorProp }) {
  const location = useLocation();
  const params = useParams();
  const { auth } = useContext(AppContext);


  // 1) id çözümü: öncelik /:id -> yoksa /:slug
  const id = useMemo(() => {
    if (params.id) return Number(params.id);
    if (params.slug) {
      const raw = extractIdFromSlug(params.slug);
      return raw && /^\d+$/.test(raw) ? Number(raw) : null;
    }
    return null;
  }, [params.id, params.slug]);

  // 2) author verisi: prop varsa onu kullan; yoksa minimal fetch
  const [authorLocal, setAuthorLocal] = useState(null);
  const author = authorProp || authorLocal;

  useEffect(() => {
    let alive = true;
    if (!authorProp && id) {
      (async () => {
        try {
          const resp = await getAuthorDetail(id, auth?.token);
          if (!alive) return;
          if (resp?.status === "OK" && resp?.data) setAuthorLocal(resp.data);
        } catch {
          // sessiz geç
        }
      })();
    }
    return () => { alive = false; };
  }, [authorProp, id]);

  // 3) nav path’ler
  const pubsPath = id ? `/authors/publications/${id}` : "";
  const publishersPath = id ? `/authors/publishers/${id}` : "";

  // 4) SEO url (bilgi sekmesi)
  const fullName = author ? `${author.name || ""} ${author.surname || ""}`.trim() : "";
  const authorSlugPath = author && id
    ? buildAuthorPath({ name: author.name, surname: author.surname, id })
    : (id ? `/authors-detail/${id}` : "");

  // 5) active state’ler
  const infoActive =
    location.pathname === authorSlugPath ||
    (id && location.pathname === `/authors-detail/${id}`);
  const pubsActive = id ? location.pathname === pubsPath : false;
  const publishersActive = id ? location.pathname === publishersPath : false;

  // 6) görsel
  const photoUrl =
    author?.photo
      ? getFilePath(`authors/displayFile/${author.id}/${author.photo}`)
      : User1;

  // id yoksa hiç render etme (route hatası)
  if (!id) return null;

  return (
    <div className="col-xl-3 col-lg-3 theiaStickySidebar">
      <StickyBox offsetTop={20} offsetBottom={20}>
        <div className="settings-widget dash-profile">
          <div className="settings-menu">
            <div className="profile-bg">
              <div className="profile-img">
                <Link to={authorSlugPath || "#"}>
                  <img crossOrigin="anonymous" src={photoUrl} alt={fullName || "Author"} />
                </Link>
              </div>
            </div>
            <div className="profile-group">
              <div className="profile-name text-center">
                {fullName ? (
                  <>
                    <h4><Link to={authorSlugPath || "#"}>{fullName}</Link></h4>
                    <p>{author?.title || ""}</p>
                  </>
                ) : (
                  // author henüz gelmediyse küçük skeleton
                  <div className="placeholder-glow my-2">
                    <span className="placeholder col-8" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="settings-widget account-settings">
          <div className="settings-menu">
            <ul>
              <li className={`nav-item ${infoActive ? "active" : ""}`}>
                <Link to={authorSlugPath || "#"} className="nav-link">
                  <i className="bx bxs-user" />
                  Yazar Bilgileri
                </Link>
              </li>

              <li className={`nav-item ${pubsActive ? "active" : ""}`}>
                <Link to={pubsPath} className="nav-link">
                  <i className="bx bxs-star" />
                  Yayınlar
                </Link>
              </li>

              <li className={`nav-item ${publishersActive ? "active" : ""}`}>
                <Link to={publishersPath} className="nav-link">
                  <i className="bx bxs-cart" />
                  Yayıncılar
                </Link>
              </li>

              <li className={`nav-item ${location.pathname === '/instructor/instructor-quiz' || location.pathname === '/instructor/instructor-quiz-details' ? 'active' : ''}`}>
                <Link className="nav-link">
                  <i className="bx bxs-shapes" />
                  Atıflar
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </StickyBox>
    </div>
  );
}
